import { useQuery } from 'react-query';
import { SecondSubactegoriesListResponse } from './categoryTypes';
import { getSecondSubcategoriesList } from './categoryService';

type Props<M> = {
    onError?: (error: Error) => void;
    onSuccess?: (data: SecondSubactegoriesListResponse) => void;
    mapper?: (
        data?: SecondSubactegoriesListResponse
    ) => M | SecondSubactegoriesListResponse | undefined;
    enabled?: boolean;
};

const defaultMapper = (data?: SecondSubactegoriesListResponse) => data;

export const useGetSecondSubCategoriesList = <M = SecondSubactegoriesListResponse>({
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
}: Props<M>) => {
    const query = useQuery<SecondSubactegoriesListResponse, Error>(
        ['secondSubcategories'],
        getSecondSubcategoriesList,
        {
            onSuccess,
            onError,
            enabled: enabled,
        }
    );

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
